import { Fragment, useContext } from 'react'
import cx from 'classnames'

import { SanityAccountDetailsStrings } from '@data/sanity/queries/types/strings'
import { getPageUrl, PageType } from '@lib/routes'
import { UserContext } from '@lib/user/context'

import ButtonLink from '@components/buttons/button-link'

interface AccountDetailsProps {
  accountStrings: SanityAccountDetailsStrings
  className?: string
}

const AccountDetails = ({ accountStrings, className }: AccountDetailsProps) => {
  const { user } = useContext(UserContext)

  const addressCount = user?.addresses?.length ?? 0
  const defaultAddress =
    user?.addresses?.find((address) => address.isDefault) ??
    user?.addresses?.[0]

  const accountAddressUrl = getPageUrl(PageType.ACCOUNT_ADDRESS_PAGE)

  return (
    <div className={cx(className, 'bg-gray-light bg-opacity-50 p-6 lg:p-8')}>
      <h4 className="font-semibold">
        {accountStrings.accountAccountDetailsHeading}
      </h4>

      {!!defaultAddress && (
        <div className="mt-5 text-sm leading-normal">
          {defaultAddress.formatted.map((addressLine, index) => (
            <Fragment key={index}>
              {addressLine}
              {defaultAddress.formatted[index + 1] && <br />}
            </Fragment>
          ))}
        </div>
      )}

      <ButtonLink
        href={accountAddressUrl}
        className="w-full mt-5 text-sm font-semibold"
        icon="ArrowRight"
        iconSize="normal"
        iconAlignment="left"
      >
        {accountStrings.accountViewAddresses} ({addressCount})
      </ButtonLink>
    </div>
  )
}

export default AccountDetails
